import React from "react";
import Styles from "./Styles.module.css";
import Slider4 from "./aboutussliders/Slider4";
import SkeletonDisplay from "../hooks/skeletonDisplay";

function FAQs() {
  return (
    <div>
      <div className={Styles.slider1}>
        <div className={Styles.mainContainer}>
          <SkeletonDisplay>
            <img src="/aboutus/aboutus.png" alt="Curd Africa" />
          </SkeletonDisplay>
          <button>Frequently Asked Questions</button>
        </div>
      </div>
      <div style={{ margin: "0 auto" }}>
        <Slider4 />
      </div>
    </div>
  );
}

export default FAQs;
